import React, { useState, useEffect } from "react";
import "../assets/css/PortraitsGallery.css";

// Lista de imágenes estáticas con créditos en blanco
const imageList = [
  { src: "IMG_1238.jpg" },
  { src: "IMG_4335.jpg" },
  { src: "IMG_9627.jpg" },
  { src: "IMG_9833.JPG" },
  { src: "4e8e54ed-cc27-4cf2-809e-1d07532206b9.jpg", credit: "" },
  { src: "63c3cffb-6a9f-4f63-a3f5-6ce55a67dc1c.jpg", credit: "" },
  { src: "157dda11-06ae-4503-872c-04908a65678c.jpg", credit: "" },
  { src: "a858fdec-416e-40fc-b08a-c8759a8c7e4a.jpg", credit: "" },
  { src: "f805f1d5-2c53-4361-9435-bad570b1a598.jpg", credit: "" },
  { src: "Laurea in canto rinascimentale e barocco.jpg", credit: "" },
  { src: "3 foto portraits.jpg", credit: "© Mattia Comandone" },
  { src: "1 foto en portraits.jpg", credit: "© Mattia Comandone" },
  { src: "IMG_9122.jpg", credit: "© Andrea Gelain Photography" },
  { src: "IMG_9255.jpg", credit: "© Andrea Gelain Photography" },
  { src: "IMG_9256.jpg", credit: "© Andrea Gelain Photography" },
  { src: "IMG_9257.jpg", credit: "© Andrea Gelain Photography" },
  { src: "2 foto portraits.jpg", credit: "© Mattia Comandone" },
  { src: "4 foto portraits.jpg", credit: "© Mattia Comandone" },
  { src: "FF4C1751-DAD3-473E-A857-70E749F7446B.jpg", credit: "" },
  { src: "5 foto portraits.jpg", credit: "© Mattia Comandone" },
  { src: "Opcional 1.jpg", credit: "" },
  { src: "Opcional 2.jpg", credit: "" },
  { src: "Opcional 3.jpg", credit: "" },
  { src: "Opcional 4.jpg", credit: "" },
];

const Portraits = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});

  // Cargar imágenes de forma asíncrona
  useEffect(() => {
    const loadImages = async () => {
      const promises = imageList.map(async (image) => {
        const loadedImage = await import(`../assets/img/portraits/${image.src}`);
        return { [image.src]: loadedImage.default };
      });

      const resolvedImages = await Promise.all(promises);
      setLoadedImages(Object.assign({}, ...resolvedImages));
    };

    loadImages();
  }, []);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const closeImageViewer = () => {
    setSelectedImage(null);
  };

  return (
    <div className="gallery-container">
      <h2>Portraits</h2>

      {/* Grilla de imágenes */}
      <div className="image-grid">
        {imageList.map((image) => (
          <div
            key={image.src}
            className="image-thumbnail-portrait"
            onClick={() => handleImageClick(image)}
          >
            {loadedImages[image.src] ? (
              <img
                src={loadedImages[image.src]}
                alt={image.src}
                className="thumbnail-img-portrait"
                loading="lazy"
              />
            ) : (
              <p>Cargando...</p>
            )}
            {image.credit !== '' && <div className="watermark">{image.credit}</div>}
          </div>
        ))}
      </div>

      {/* Visor de imagen en pantalla completa */}
      {selectedImage && (
        <div className="image-viewer">
          <span className="close-button" onClick={closeImageViewer}>
            &times;
          </span>
          <img
            src={require(`../assets/img/portraits/${selectedImage.src}`)}
            alt="Selected"
            className="full-screen-image"
          />
          {selectedImage.credit && (
            <div className="watermark-fullscreen">{selectedImage.credit}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default Portraits;
